import axios from 'axios'
import { postStatusToChannel } from '../../channels/user-presence-channel'

export default {
    namespaced: true,
    state() {
        return {
            user_id: null,
            loadingActivity: false,
            activity: {
                status: 'offline',
                label: 'Inactive',
                class: 'is-inactive'
            },
            activities: [
                {
                    status: "online",
                    label: "Active",
                    class: "is-active"
                },
                {
                    status: "training",
                    label: "Training",
                    class: "is-training"
                },
                {
                    status: "lunch",
                    label: "Lunch Time",
                    class: "is-lunch-time"
                },
                {
                    status: "dnd",
                    label: "Do not disturb",
                    class: "is-dnd"
                }
            ],
            busy_activities: [
                {
                    status: "busy",
                    label: "Visit",
                    class: "is-visit"
                },
                {
                    status: "busy",
                    label: "Call",
                    class: "is-call"
                },
                {
                    status: "busy",
                    label: "Video Call",
                    class: "is-video-call"
                }
            ]
        }
    },
    getters: {
        currentActivity: state => state.activity,
        availableActivities: (state) => (status) => {
            // Use the filter function to create a new array without current status
            return state.activities.filter((item) => item.status !== status)
        },
        userId: state => state.user_id,
    },
    mutations: {
        SET_CURRENT_ACTIVITY(state, payload) {
            state.activity = { ...payload }
        },
        SET_LOADING_ACTIVITY(state, payload) {
            state.loadingActivity = payload
        },
        SET_USER_ID(state, payload) {
            state.user_id = payload
        }
    },
    actions: {
        // Set the current activity based on the provided status
        setCurrentActivity({ commit, state }, [activityStatus, activityLabel = null, mainProcess = true]) {
            if (activityStatus === state.activity.status) return

            commit("SET_LOADING_ACTIVITY", true)

            const inactive = {
                status: 'offline',
                label: 'Inactive',
                class: 'is-inactive'
            }

            const activities = (activityStatus === 'busy' ? state.busy_activities : state.activities)

            const activity = activityStatus === 'busy'
                ? activities.find(activity => activity.label === activityLabel)
                : activities.find(activity => activity.status === activityStatus)

            let finalActivity = activity || inactive

            // Send updated status to other tabs
            if (state.user_id && mainProcess) {
                postStatusToChannel(state.user_id, finalActivity.status)
            }

            commit("SET_CURRENT_ACTIVITY", finalActivity)
            commit("SET_LOADING_ACTIVITY", false)
        },
        setUserId({ commit }, userId) {
            commit('SET_USER_ID', userId)
        },
    }
}